<template>
    <div class="px-6 py-3">
        <h2 class="text-xl font-bold mb-4">Transactions</h2>
        <table class="w-full border-collapse">
            <thead>
                <tr class="bg-gray-200 text-gray-800">
                    <th class="p-3 rounded-tl-lg">Description</th>
                    <th class="p-3">Credit</th>
                    <th class="p-3">Debit</th>
                    <th class="p-3 rounded-tr-lg">Date</th>
                </tr>
            </thead>
            <tbody v-if="bankStatement?.transactions?.length">
                <tr v-for="(transaction, index) in paginatedTransactions" :key="index" class="bg-white shadow-md rounded-lg">
                    <td class="p-3">{{ transaction.description }}</td>
                    <td class="p-3">{{ transaction.credit }}</td>
                    <td class="p-3">{{ transaction.debit }}</td>
                    <td class="p-3">{{ formatDate(transaction.date) }}</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="4" class="p-4 text-center text-gray-500">No Bank Statement available</td>
                </tr>
            </tbody>
        </table>
        <div class="flex justify-center mt-4 space-x-4">
            <button @click="prevPage" :disabled="currentPage === 1" class="px-4 py-2 bg-gray-300 rounded">
                Previous
            </button>
            <span class="px-4 py-2">Page {{ currentPage }} of {{ totalPages }}</span>
            <button @click="nextPage" :disabled="currentPage === totalPages" class="px-4 py-2 bg-gray-300 rounded">
                Next
            </button>
        </div>
    </div>

</template>

<script>


export default {
    name: 'BankStatement',
    data() {
        return {
            currentPage:1,
            pageSize:10,
            bankStatement : { transactions : []}
        };
    },
    mounted() {
        const savedData = sessionStorage.getItem('bankStatement');
        this.bankStatement = savedData ? JSON.parse(savedData) : { transactions: [] };
    },
    computed:{
        paginatedTransactions(){
            const start  = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.bankStatement.transactions.slice(start, end);
        },
        totalPages(){
            return this.bankStatement?.transactions?.length
            ? Math.ceil(this.bankStatement.transactions.length / this.pageSize)
            : 1;
        }
    },
    props:{
        user: Object,
    },
    methods:{

        formatDate(dateString) {
            if (!dateString) return "";
                return dateString.slice(0, 10);
            },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        }
    }
    
}

</script>
